import { CashSyncIcon } from './CashSyncIcon';

/**
 * author: Michael Irigoyen
 * id 6F96F219-FD7D-4EB5-B341-777F00AF6EBB
 * name cash-sync
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cash-sync.svg
 * tags
 * - Banking 
 * - Currency 
 */
export const CashCycleIcon = CashSyncIcon;
export default CashCycleIcon